export default {"src":"/_next/static/media/sightsea-white.967165c1.svg","height":33,"width":160,"blurWidth":0,"blurHeight":0};